import { render, staticRenderFns } from "./info-title-params.vue?vue&type=template&id=1e153f9a&"
import script from "./info-title-params.vue?vue&type=script&lang=js&"
export * from "./info-title-params.vue?vue&type=script&lang=js&"
import style0 from "./info-title-params.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e153f9a')) {
      api.createRecord('1e153f9a', component.options)
    } else {
      api.reload('1e153f9a', component.options)
    }
    module.hot.accept("./info-title-params.vue?vue&type=template&id=1e153f9a&", function () {
      api.rerender('1e153f9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/info-menu/info-title-params.vue"
export default component.exports